import { CancellationEndpoint } from './types';

export const stepsInOrder: readonly CancellationEndpoint[] = ['reason', 'date', 'confirm', 'success'];
